/** Rubrique Alertes et seuils : stock faible, mois de couverture, dormante, comportement rupture. */
import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { metaApi, parametresApi } from '../../../services/api';
import { Button, Spinner, Card, SegmentedControl } from '../../../components/ui/kit';

const RUPTURE = [{ value: 'masquer', label: 'Masquer' }, { value: 'mentionner', label: 'Mentionner [Rupture]' }];

export default function AlertesSeuils() {
  const [est, setEst] = useState(null);
  useEffect(() => { metaApi.settings().then(setEst); }, []);
  if (!est) return <Spinner />;
  const set = (k, v) => setEst({ ...est, [k]: v });
  const save = async () => { await parametresApi.updateEstablishment(est); toast.success('Seuils enregistrés'); };

  return (
    <div className="max-w-[560px]">
      <h2 className="font-title text-3xl mb-5">Alertes et seuils</h2>
      <Card className="p-5 space-y-4">
        <Row label="Seuil de stock faible par défaut (btl)"><input type="number" className="vd-input h-9 w-24" value={est.low_stock_default ?? 3} onChange={(e) => set('low_stock_default', Number(e.target.value))} data-testid="low-stock" /></Row>
        <Row label="Mois de couverture pour les commandes"><input type="number" className="vd-input h-9 w-24" value={est.coverage_months ?? 3} onChange={(e) => set('coverage_months', Number(e.target.value))} /></Row>
        <Row label="Délai « dormante » (mois)"><input type="number" className="vd-input h-9 w-24" value={est.dormant_months ?? 6} onChange={(e) => set('dormant_months', Number(e.target.value))} /></Row>
        <div>
          <p className="kicker mb-1.5">Comportement en rupture</p>
          <SegmentedControl options={RUPTURE} value={est.rupture_behavior || 'masquer'} onChange={(v) => set('rupture_behavior', v)} testId="rupture-behavior" />
        </div>
        <Button variant="primary" onClick={save} data-testid="alertes-save">Enregistrer</Button>
      </Card>
    </div>
  );
}

function Row({ label, children }) {
  return <div className="flex items-center justify-between"><span className="text-[13.5px]">{label}</span>{children}</div>;
}
